export default __webpack_public_path__ + "static/media/proViver.1f8fb46e.jpg";